var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 65,
    viewBox: "0 0 52 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.148 22.673v-8.116l-7.285-7.285a1.962 1.962 0 1 1 2.775-2.774l7.284 7.285a3.924 3.924 0 0 1 1.15 2.774v4.193l-3.924 3.923z",
    fill: "#BDF7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.071 33.612-3.923-7.015v29.902a1.962 1.962 0 0 1-3.924 0v-15.04a7.847 7.847 0 0 0-7.847-7.847l-3.923 1.961 3.923 1.962a3.923 3.923 0 0 1 3.924 3.924v15.04a5.885 5.885 0 1 0 11.77 0V33.612z",
    fill: "#504B83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.454 0H27.53v15.694l7.847-7.847V3.924A3.923 3.923 0 0 0 31.454 0z",
    fill: "#F52314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.53 0H5.95a3.923 3.923 0 0 0-3.923 3.924v3.923l29.427 9.809V3.924A3.923 3.923 0 0 0 27.53 0z",
    fill: "#FF4D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F52314",
    d: "M35.377 41.459v21.58H19.683l11.77-21.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D1C",
    d: "M2.027 41.459h29.427v21.58H2.027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.377 61.076h-3.923V65h3.923a1.962 1.962 0 0 0 0-3.924z",
    fill: "#5B3364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.415 63.038a1.962 1.962 0 0 0-1.961-1.962H2.027a1.962 1.962 0 0 0 0 3.924h29.427a1.962 1.962 0 0 0 1.961-1.962z",
    fill: "#504B83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CF0EE",
    d: "m31.454 7.847-7.847 16.806 7.847 16.806h3.923V7.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDF7F7",
    d: "M2.027 7.847V41.46h29.427v-11.77l-11.77-8.96 11.77-8.958V7.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B3364",
    d: "m21.645 33.612-2.878 1.961 2.878 1.962h5.885v-3.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#504B83",
    d: "m15.76 33.612-2.878 1.961 2.878 1.962h5.885v-3.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4663A2",
    d: "M9.874 33.612h5.886v3.923H9.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3193E0",
    d: "m27.53 11.77-7.847 8.96 7.847 8.958h3.924V11.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26ABFF",
    d: "M5.95 11.77h21.58v17.918H5.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F52314",
    d: "m47.148 18.75-1.962 1.961V31.65l1.962 1.962h3.923V18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.186 18.75a1.962 1.962 0 0 0-1.962 1.961V31.65c0 1.083.879 1.962 1.962 1.962h1.962V18.75h-1.962z",
    fill: "#FF4D1C"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.b650ae394e29e4491d2f18ef725c655b.svg";
export { ForwardRef as ReactComponent };